module.exports = __webpack_public_path__ + "img/shop_environ_3.7756975b.jpg";